import { SceneScheduleTime } from './scene-schedule-time.model';

export class SceneScheduleStartEndTimes
{
    constructor(json: any = null)
    {
        if (json)
        {
            if (json.Enabled)
            {
                this.Enabled = json.Enabled;
            }

            if (json.StartTime)
            {
                this.StartTime = new SceneScheduleTime(json.StartTime);
            }

            if (json.EndTime)
            {
                this.EndTime = new SceneScheduleTime(json.EndTime);
            }

            return;
        }

        this.StartTime = new SceneScheduleTime();
        this.EndTime = new SceneScheduleTime();
    }

    public Enabled: boolean;
    public StartTime: SceneScheduleTime;
    public EndTime: SceneScheduleTime;
}
